import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import StoreItem from './StoreItem';

const BORDER_POSITION_IN_STORE_ITEMS = {
  0: 'border-b border-r md:border-b-0',
  1: 'border-b md:border-r md:border-b-0',
  2: 'border-r',
};
const STORE_ITEMS = [
  {
    title: 'Aliexpress',
    icon: 'aliexpress',
    toRedirectUrlWithUtms: (searchQuery) =>
      `https://s.click.aliexpress.com/deep_link.htm?aff_short_key=_DlGjKW7&dl_target_url=https://pt.aliexpress.com/wholesale?catId=0&SearchText=${encodeURIComponent(
        searchQuery
      )}`,
  },
  {
    title: 'Amazon',
    icon: 'amazon',
    toRedirectUrlWithUtms: (searchQuery) =>
      `https://www.amazon.com.br/s?k=${encodeURIComponent(
        searchQuery
      )}&tag=promobit04-20`,
  },
  {
    title: 'Americanas',
    icon: 'americanas',
    toRedirectUrlWithUtms: (searchQuery) =>
      `https://www.awin1.com/cread.php?awinmid=22193&awinaffid=889130&ued=https%3A%2F%2Fwww.americanas.com.br%2Fbusca%3Fconteudo%3D${encodeURIComponent(
        searchQuery
      )}`,
  },
  {
    title: 'Casas Bahia',
    icon: 'casas-bahia',
    toRedirectUrlWithUtms: (searchQuery) =>
      `https://www.casasbahia.com.br/${encodeURIComponent(searchQuery)}/b`,
  },
];

const getBorderStylesProps = (position) =>
  BORDER_POSITION_IN_STORE_ITEMS[position];

const StoresList = ({ gaEventCategory, searchQuery }) => (
  <div className="mt-6 grid grid-cols-2 grid-rows-2 md:grid-cols-4 md:grid-rows-1">
    {STORE_ITEMS.map(({ title, icon, toRedirectUrlWithUtms }, index) => (
      <StoreItem
        key={index}
        className={twJoin(
          'border-neutral-high-400 dark:border-neutral-low-300',
          getBorderStylesProps(index)
        )}
        gaEventCategory={gaEventCategory}
        icon={icon}
        title={title}
        url={toRedirectUrlWithUtms(searchQuery)}
      />
    ))}
  </div>
);

StoresList.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  searchQuery: PropTypes.string.isRequired,
};

export default StoresList;
